module.exports = __webpack_public_path__ + "img/february-blue.dc2247e1.svg";